export const API_ROOT = process.env.NODE_ENV === 'production' ? 'https://ias.digitalatyrau.kz' : 'https://ias.digitalatyrau.kz';
